import { orderArrayByProp } from 'lmcv/utils/formatters'

import LoyaltyStatus from './LoyaltyStatus'

const getLinks = status => {
  return [
    {
      order: 1,
      name: 'Início',
      link: '/fidelidade'
    },
    {
      order: 2,
      name: 'Minhas vantagens',
      link: '/fidelidade/minhas-vantagens'
    },
    {
      order: 3,
      name: 'Troque',
      link: '/fidelidade/troque'
    },
    {
      order: 4,
      name: 'Meus pontos',
      link:
        status.is(7)
          ? '/fidelidade/pro-meus-pontos'
          : '/fidelidade/meus-pontos'
    },
    {
      order: 6,
      name: 'Dúvidas',
      link: '/fidelidade/duvidas'
    }
  ]
}

const getProLinks = status => {
  if (!status.isProEAD()) return []

  const links = [
    {
      order: 5,
      name: 'Clientes',
      link: '/fidelidade/clientes'
    }
  ]

  return links
}

const loyaltyMenu = ({ loyaltyProgramCode, loyaltyProRelationship }) => {
  const status = LoyaltyStatus(loyaltyProgramCode)

  if (!status.isActive()) {
    return []
  }

  if (!loyaltyProRelationship) {
    return getLinks(status)
  }

  const links = [...getLinks(status), ...getProLinks(status)]
  return links.length ? orderArrayByProp(links, 'order') : []
}

export default loyaltyMenu
